export default __webpack_public_path__ + "static/media/IconFilter.5554a174.svg";